import axios from 'axios';
import api from './api';

export const previewDocument = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post('/preview-document', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response.data;
};

export const processDocument = async (file, extractionConfig = null) => {
  const formData = new FormData();
  formData.append('file', file);

  if (extractionConfig?.accessKey) {
    formData.append('extraction_config', JSON.stringify({
      access_key: extractionConfig.accessKey,
      prompt: extractionConfig.promptTemplate,
      excel_template_type: extractionConfig.excelTemplateType,
      fields_config: extractionConfig.fieldsConfig,
    }));
  }

  const response = await api.post('/process-document', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const getExtractionAnalysis = async (analysisHash, accessKey) => {
  const response = await api.get(`/extraction-analysis/${analysisHash}`, {
    params: { access_key: accessKey }
  });
  return response.data;
};

export const getExtractionAnalysisPreview = async (analysisHash, accessKey) => {
  const response = await axios.get(`/api/extraction-analysis/${analysisHash}/preview`, {
    params: { accessKey }
  });
  return response.data;
};

export const saveExtractionAnalysis = async (file, accessKey, extractionResult, tokenUsage, processingTime, analysisHash, userHash) => {
  const formData = new FormData();
  if (file) formData.append('file', file);
  formData.append('access_key', accessKey);
  formData.append('extraction_result', JSON.stringify(extractionResult));
  formData.append('input_tokens', tokenUsage?.input_tokens || 0);
  formData.append('output_tokens', tokenUsage?.output_tokens || 0);
  formData.append('total_tokens', tokenUsage?.total_tokens || 0);
  formData.append('processing_time', processingTime || 0);
  if (analysisHash) formData.append('analysis_hash', analysisHash);
  if (userHash) formData.append('user_hash', userHash);

  const response = await api.post('/save-extraction-analysis', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

  return response.data;
};

